class ServiceOrdersService {
  constructor ($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.$httpParamSerializerJQLike= $httpParamSerializerJQLike;
  }

  getServiceOrdersHead(userDocument) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + '/' + this.ngAuthSettings.config.paths.PAYMENT_ADVANCED.ORDERS_SERVICE_HEAD +
        (userDocument ? '?valor=' + userDocument : ''),
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  getServiceOrdersDetail(documentNumber) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + '/' + this.ngAuthSettings.config.paths.PAYMENT_ADVANCED.ORDERS_SERVICE_DETAIL +
        (documentNumber ? '?valor=' + documentNumber : ''),
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  userUpdate(data) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + '/' + this.ngAuthSettings.config.paths.userUpdate,
        data: this.$httpParamSerializerJQLike(data),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
}

ServiceOrdersService.$inject = ['$q','$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];

export default ServiceOrdersService;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/payments-advances/service-orders/service-orders.service.js
 **/